import { type WorkspaceAgentOnboardingTimeSinkId } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentOnboardingHandoff';
import { parseWorkspaceAgentOnboardingTimeSinksSearch } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentOnboardingRoleHandoff';
import { useWorkspaceAgentPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';
import { useRouterSelector } from '~/hooks/useRouterSelector';

const EMPTY_TIME_SINK_IDS: readonly WorkspaceAgentOnboardingTimeSinkId[] = [];

export const useWorkspaceAgentOnboardingTimeSinkIds = (): {
  timeSinkIds: readonly WorkspaceAgentOnboardingTimeSinkId[];
} => {
  const handoffTimeSinkIds = useWorkspaceAgentPanelStore((state) => state.onboardingHandoff?.timeSinkIds);
  const timeSinkIdsFromUrl =
    useRouterSelector((location) => parseWorkspaceAgentOnboardingTimeSinksSearch(location.search)) ??
    EMPTY_TIME_SINK_IDS;

  if (handoffTimeSinkIds && handoffTimeSinkIds.length > 0) {
    return { timeSinkIds: handoffTimeSinkIds };
  }

  return { timeSinkIds: timeSinkIdsFromUrl };
};
